module.exports = {"410211001":"城西街道","410211002":"梁苑街道","410211100":"杏花营镇","410211201":"西郊乡","410211207":"水稻乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410211.json
// module id = 1532
// module chunks = 0